import { FoodsIcon, TextTitleGreyIcon } from "@foodpilot/foods";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Fragment } from "react";

import DoubleCheck from "src/assets/icons/double-check.svg?react";
import { useTranslation } from "react-i18next";

type HeaderProps = {
    openModal: () => void;
};
export const Header = (props: HeaderProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Fragment>
            <Box sx={{ marginBottom: theme.spacing(1.25) }}>
                <TextTitleGreyIcon
                    title={"liste_des_emballages_du_produit_1"}
                    icon={<FoodsIcon size={1} icon="packaging" />}
                    titleSize="h3"
                />
            </Box>
            <Box sx={{ borderTop: `1px solid ${theme.custom.grey[500]}` }}>
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "end",
                        marginBlock: theme.spacing(2.25),
                    }}
                >
                    <Button variant="ternary" startIcon={<DoubleCheck />} onClick={props.openModal}>
                        <Typography variant="body-bold">{t("ajouter_ou_retirer_des_emballages")}</Typography>
                    </Button>
                </Box>
            </Box>
        </Fragment>
    );
};
